import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { faPlus } from '@fortawesome/pro-regular-svg-icons/faPlus'
import { TextInput } from '@peracto/peracto-editor-ui'

import AccountNumberRestrictionsList from './AccountNumberRestrictionsList'

const AccountNumberRestrictions = ({ settings, setSettings }) => {
    const [accountNumber, setAccountNumber] = useState('')

    return (
        <div data-testid={`related-products-section`}>
            <label className="!mt-2">Main Account Number Restrictions</label>

            <AccountNumberRestrictionsList settings={settings} setSettings={setSettings} />

            <div data-testid="account-number-restriction" className="!flex !flex-row items-center">
                <div className="flex-grow">
                    <TextInput
                        placeholder={'Main Account Number'}
                        data-testid={'input-account-number'}
                        value={accountNumber}
                        onChange={e => {
                            setAccountNumber(e.target.value)
                        }}
                        onKeyDown={e => {
                            if (e.keyCode === 13 /* Enter */) {
                                if (accountNumber?.length > 0) {
                                    setSettings({
                                        ...settings,
                                        contentBabbageAccountRestriction: [
                                            ...settings.contentBabbageAccountRestriction,
                                            { babbageAccount: accountNumber },
                                        ],
                                    })
                                    setAccountNumber('')
                                }
                            }
                        }}
                        wrapperClassName="!mb-0"
                        className="!mb-0"
                    />
                </div>

                <button
                    title="Add"
                    className="btn btn-success !ml-2"
                    data-testid="content-add"
                    disabled={accountNumber?.length === 0}
                    onClick={e => {
                        e.preventDefault()
                        e.stopPropagation()
                        if (accountNumber?.length > 0) {
                            setSettings({
                                ...settings,
                                contentBabbageAccountRestriction: [
                                    ...settings.contentBabbageAccountRestriction,
                                    { babbageAccount: accountNumber },
                                ],
                            })
                            setAccountNumber('')
                        }
                    }}
                >
                    <FontAwesomeIcon icon={faPlus} />
                </button>
            </div>
        </div>
    )
}

export default AccountNumberRestrictions
